import React, { useEffect, useState } from 'react';
import { Form, Tooltip } from 'antd';
import axios from 'axios';
import { useAuth } from "../context/AuthContext";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline, IoMdLogIn } from "react-icons/io";
import { HiOutlineDocumentCheck } from "react-icons/hi2";

const withWorkOrderAllocationLogic = (Component: React.ComponentType<any>) => {
    return (props: any) => {
        const [form] = Form.useForm();
        const { userData } = useAuth();
        const [foremanOptions, setForemanOptions] = useState<{ label: string, value: string }[]>([]);
        const [warehouseCode, setWarehouseCode] = useState<string>('');
        const [technicianData, setTechnicianData] = useState<any[]>([]);

        const navigate = useNavigate();
        const transformStyle = {
            transform: "scale(0.80)",
            transformOrigin: "top left",
            width: "125%",
        };

        const Printbtn = IoPrintSharp as React.ComponentType<any>;
        const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
        const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
        const InAllocate = IoMdLogIn as React.ComponentType<any>;

        const TechnicianWorkOrderAllocation = [
            { title: 'Technician', dataIndex: 'technician_name', key: 'technician' },
            {
                title: 'List Operation',
                dataIndex: 'operations_json',
                key: 'operation',
                render: (val: any) => (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                        {val && val.map((item: any, index: number) => (
                            <Tooltip
                                title={
                                    <div>
                                        <div><strong>WO No :</strong> {item.wo}</div>
                                        <div><strong>Operation :</strong> {item.op_name}</div>
                                        <div><strong>FRT :</strong> {item.frt}</div>
                                        <div>
                                            <strong>Status :</strong> {
                                                item.status === 'QCP' ? 'QC Pass' :
                                                    item.status === 'P' ? 'Paused' :
                                                        item.status === 'OP' ? 'On Going' : item.status
                                            }
                                        </div>
                                    </div>
                                }
                                color={item.status === 'QCP' ? '#52c41a' : item.status === 'P' ? '#ff4d4f' : '#fa8c16'}
                                trigger="click"
                                key={index}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                            >
                                <div style={{
                                    backgroundColor: item.status === 'QCP' ? '#52c41a' : item.status === 'P' ? '#ff4d4f' : '#fa8c16',
                                    color: '#565855',
                                    padding: '2px 10px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    fontWeight: '',
                                    display: 'inline-block'
                                }}>
                                    {item.op}
                                </div>
                            </Tooltip>
                        ))}
                    </div>
                )
            },
        ];

        const handleDateChange = async (date: any) => {
            if (date && warehouseCode) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-allocation/foreman-list`, {
                        params: { warehouse_code: warehouseCode }
                    });
                    const options = response.data.map((item: any) => ({
                        label: item.name,
                        value: item.code
                    }));
                    setForemanOptions(options);
                    setTechnicianData([]);
                    form.setFieldValue('foreman', undefined);
                } catch (error) {
                    console.error("Error fetching foreman list:", error);
                }
            } else {
                setForemanOptions([]);
            }
        };

        const handleForemanChange = async (foremanValue: string) => {
            const serviceDate = form.getFieldValue('service_date');

            if (serviceDate && foremanValue) {
                const formattedDate = dayjs(serviceDate).format('DD/MM/YYYY');

                try {
                    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-allocation/technician-list`, {
                        params: {
                            date_trans: formattedDate,
                            foreman: foremanValue
                        }
                    });

                    setTechnicianData(response.data);
                } catch (error) {
                    console.error("Error fetching technician list:", error);
                }
            }
        };

        useEffect(() => {
            const fetchUserWarehouse = async () => {
                if (userData?.users) {
                    try {
                        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/work-order-allocation/user-warehouse`, {
                            params: { username: userData.users }
                        });

                        if (response.data && response.data.warehouse_name) {
                            setWarehouseCode(response.data.warehouse_code);
                            form.setFieldsValue({
                                warehouse: response.data.warehouse_name
                            });
                        }
                    } catch (error) {
                        console.error("Error fetching warehouse data:", error);
                    }
                }
            };

            fetchUserWarehouse();
        }, [userData, form]);


        return (
            <Component
                {...props}
                form={form}
                foremanOptions={foremanOptions}
                handleDateChange={handleDateChange}
                technicianData={technicianData}
                handleForemanChange={handleForemanChange}
                navigate={navigate}
                transformStyle={transformStyle}
                Printbtn={Printbtn}
                Voidbtn={Voidbtn}
                Submitbtn={Submitbtn}
                InAllocate={InAllocate}
                TechnicianWorkOrderAllocation={TechnicianWorkOrderAllocation}
                warehouseCode={warehouseCode}
            />
        );
    };
};

export default withWorkOrderAllocationLogic;